/*🤫
🤫
🤫
🤫*/
class Debug {
    static writeCookie() {
        window.o_util.cookie.set(Debug.cookieName, "true");
    }
    static isCookieSet() {
        return window.o_util.cookie.exists(Debug.cookieName);
    }
    /*🤫
🤫
🤫
🤫
🤫
🤫*/
    static status() {
        if (Debug.isCookieSet()) {
            Debug.statusObject.activated = true;
            Debug.statusObject.text = "activated";
        }
        else {
            Debug.statusObject.activated = false;
            Debug.statusObject.text = "deactivated";
        }
        return Debug.statusObject;
    }
    /*🤫
🤫
🤫
🤫
🤫*/
    static activate() {
        if (!Debug.status().activated) {
            Debug.writeCookie();
        }
        return Debug.status().text;
    }
    /*🤫
🤫
🤫
🤫
🤫*/
    static deactivate() {
        if (Debug.status().activated) {
            window.o_util.cookie.remove(Debug.cookieName);
        }
        return Debug.status().text;
    }
    static warn(message) {
        if (Debug.status().activated) {
            /*🤫*/
            console.warn(message);
        }
    }
}
Debug.cookieName = "debug";
Debug.statusObject = {
    activated: undefined,
    text: undefined,
};

const { status, deactivate, activate, warn } = Debug;

export { Debug, activate, deactivate, status, warn };
